import * as React from 'react';

import { Container, Description, Header, HeadersContainer, Subheader } from './infoBox.styled';
import { InfoBoxProps } from './infoBox.types';

export const InfoBox: React.FC<InfoBoxProps> = (props: InfoBoxProps) => {
  const { infoBoxTheme, header, subheader, description, className }: InfoBoxProps = props;

  return (
    <Container $theme={infoBoxTheme} className={className}>
      <HeadersContainer>
        <Header $theme={infoBoxTheme}>{header}</Header>
        <Subheader $theme={infoBoxTheme}>{subheader}</Subheader>
      </HeadersContainer>
      <Description $theme={infoBoxTheme} text={description} />
    </Container>
  );
};
